import { render, staticRenderFns } from "./AppDefaultFooter.vue?vue&type=template&id=3bff70fe&scoped=true"
import script from "./AppDefaultFooter.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppDefaultFooter.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./AppDefaultFooter.vue?vue&type=style&index=0&id=3bff70fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff70fe",
  null
  
)

export default component.exports